import template from './routes.all.html';
import controller from './routes.all.controller';
import './routes.all.scss';

let routesallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default routesallComponent;


// WEBPACK FOOTER //
// ./client/app/components/routes/all/routes.all.component.js